import "./landing.scss";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useResetRecoilState } from "recoil";
import {
  atomCurrentStep,
  atomFormikInsurance,
  atomFormikGroup,
  atomIsGroup,
  atomPolicy,
  atomQuestionnaire,
  atomProvinces,
  atomEvaluatePremium,
} from "src/storage";

export const useLanding = () => {
  const resetFormikMainInsured = useResetRecoilState(atomFormikInsurance);
  const resetFormikMainGroup = useResetRecoilState(atomFormikGroup);
  const resetCurrentStep = useResetRecoilState(atomCurrentStep);
  const resetIsGroup = useResetRecoilState(atomIsGroup);
  const resetPolicy = useResetRecoilState(atomPolicy);
  const resetQuestionnaire = useResetRecoilState(atomQuestionnaire);
  const resetProvinces = useResetRecoilState(atomProvinces);
  const resetEvaluatePremium = useResetRecoilState(atomEvaluatePremium);
  const { t } = useTranslation();

  useEffect(() => {
    //Insurance
    resetFormikMainInsured();
    resetCurrentStep();

    // Group
    resetFormikMainGroup();
    resetIsGroup();

    //Policy
    resetPolicy();

    //Questionnaire
    resetQuestionnaire();

    //Viario
    resetProvinces();

    //Premium
    resetEvaluatePremium();
  }, []);

  return { t };
};
